import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

class Message extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, title, text } = this.props;
    return (
      <div className='fe-message-container'>
        <div className='container'>
          <div className='row'>
            <div className='col'>
              <h1 className='fe-heading'>{t(title)}</h1>
              <p dangerouslySetInnerHTML={{ __html: t(text) }} />
              <a className='fe-link' href='/getaways'>
                {t('gen:goHome')}
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Message.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired
};

Message.defaultProps = {
  title: 'support:thankYouMessage',
  text: 'support:thankYouText'
};

export default withTranslation()(Message);
